import React, { memo } from 'react';
import { _cs } from '@togglecorp/fujs';
import logo from '#resources/img/logo.png';

import styles from './styles.scss';

interface Props {
    className?: string;
}

const Header = ({ className: classNameFromProps }: Props) => {
    const className = _cs(
        classNameFromProps,
        styles.header,
    );

    return (
        <header className={className}>
            <div className={styles.left}>
                <img
                    className={styles.image}
                    src={logo}
                    alt="Logo"
                />
            </div>
            <div className={styles.right}>
                <h1 className={styles.heading}>
                    Golden Community
                </h1>
                <p className={styles.description}>
                    Electronic Management System
                </p>
            </div>
        </header>
    );
};

export default memo(Header);
